/* ==========================================================================
   Mondō London — maker index wall
   Makers form measured, fully justified rows with separators only between
   names. A piece from the maison follows the cursor across its row; hidden on
   scroll and leave. Pointer devices only; reduced motion uses direct placement.
   ========================================================================== */
(function () {
  'use strict';
  var wall = document.querySelector('.mwall');
  if (!wall) return;
  var makers = Array.prototype.slice.call(wall.querySelectorAll('.mrow'));
  var lastLayoutWidth = -1;
  var layoutTimer = null;

  function measureDash() {
    var measure = document.createElement('span');
    measure.className = 'mdash';
    measure.textContent = '\u2014';
    measure.style.position = 'absolute';
    measure.style.visibility = 'hidden';
    measure.style.whiteSpace = 'nowrap';
    measure.style.padding = '0';
    wall.appendChild(measure);
    var width = measure.getBoundingClientRect().width;
    wall.removeChild(measure);
    return width;
  }

  function packedWidth(row, widths, dashWidth, minimumGap) {
    var width = 0;
    for (var i = 0; i < row.length; i += 1) width += widths[row[i]];
    if (row.length > 1) width += (row.length - 1) * (dashWidth + minimumGap * 2);
    return width;
  }

  function layoutMakers(force) {
    if (makers.length < 2 || !window.getComputedStyle) return;
    var style = window.getComputedStyle(wall);
    var contentWidth = wall.clientWidth - parseFloat(style.paddingLeft || 0) - parseFloat(style.paddingRight || 0);
    if (contentWidth <= 0 || (!force && Math.abs(contentWidth - lastLayoutWidth) < 1)) return;
    lastLayoutWidth = contentWidth;

    var widths = makers.map(function (maker) { return maker.getBoundingClientRect().width; });
    var dashWidth = measureDash();
    var minimumGap = (parseFloat(style.fontSize) || 22) * 0.18;
    var rows = [];
    var row = [];
    var rowWidth = 0;

    for (var i = 0; i < makers.length; i += 1) {
      var addition = widths[i] + (row.length ? dashWidth + minimumGap * 2 : 0);
      if (row.length && rowWidth + addition > contentWidth) {
        rows.push(row);
        row = [i];
        rowWidth = widths[i];
      } else {
        row.push(i);
        rowWidth += addition;
      }
    }
    if (row.length) rows.push(row);

    // Keep the closing row useful without changing the makers' reading order.
    for (var r = rows.length - 1; r > 0; r -= 1) {
      var previous = rows[r - 1];
      var current = rows[r];
      while (previous.length > current.length + 1 && previous.length > 2) {
        var candidate = [previous[previous.length - 1]].concat(current);
        if (packedWidth(candidate, widths, dashWidth, minimumGap) > contentWidth) break;
        current.unshift(previous.pop());
      }
    }

    var fragment = document.createDocumentFragment();
    rows.forEach(function (makerRow) {
      var line = document.createElement('div');
      line.className = 'mwall-line';
      line.setAttribute('role', 'presentation');
      makerRow.forEach(function (makerIndex, index) {
        if (index > 0) {
          var separator = document.createElement('span');
          separator.className = 'mdash';
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = '\u2014';
          line.appendChild(separator);
        }
        line.appendChild(makers[makerIndex]);
      });
      fragment.appendChild(line);
    });

    wall.textContent = '';
    wall.appendChild(fragment);
    wall.classList.add('is-laid-out');
  }

  layoutMakers(false);
  window.addEventListener('resize', function () {
    clearTimeout(layoutTimer);
    layoutTimer = setTimeout(function () { layoutMakers(false); }, 100);
  }, { passive: true });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { layoutMakers(true); }).catch(function () {});
  }

  var thumb = document.querySelector('[data-mthumb]');
  if (!thumb) return;
  if (window.matchMedia && !window.matchMedia('(pointer: fine)').matches) return;
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var tx = 0, ty = 0, cx = 0, cy = 0, visible = false, raf = null;

  function reduceMotion() {
    return motionQuery && motionQuery.matches;
  }

  function placeThumb() {
    thumb.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
  }

  function tick() {
    if (reduceMotion()) {
      cx = tx;
      cy = ty;
      placeThumb();
      raf = null;
      return;
    }
    // gentle pursuit — the image trails the cursor rather than sticking to it
    cx += (tx - cx) * 0.16;
    cy += (ty - cy) * 0.16;
    placeThumb();
    if (visible) raf = requestAnimationFrame(tick);
    else raf = null;
  }

  function updatePosition(e) {
    var rect = thumb.getBoundingClientRect();
    var pad = 16;
    var width = rect.width || 240;
    var height = rect.height || 320;
    tx = Math.max(pad, Math.min(e.clientX + 28, window.innerWidth - width - pad));
    ty = Math.max(pad, Math.min(e.clientY - 120, window.innerHeight - height - pad));
    if (reduceMotion()) {
      cx = tx;
      cy = ty;
      placeThumb();
    } else if (visible && raf === null) {
      raf = requestAnimationFrame(tick);
    }
  }

  wall.addEventListener('mousemove', function (e) {
    updatePosition(e);
  });

  wall.addEventListener('mouseover', function (e) {
    var row = e.target.closest ? e.target.closest('.mrow') : null;
    if (!row) return;
    var src = row.getAttribute('data-thumb');
    if (!src) { thumb.classList.remove('is-on'); visible = false; return; }
    if (thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
    updatePosition(e);
    if (!visible) { cx = tx; cy = ty; }
    visible = true;
    thumb.classList.add('is-on');
    if (!reduceMotion() && raf === null) raf = requestAnimationFrame(tick);
  });

  wall.addEventListener('mouseleave', function () {
    visible = false;
    thumb.classList.remove('is-on');
  });

  window.addEventListener('scroll', function () {
    if (visible) { visible = false; thumb.classList.remove('is-on'); }
  }, { passive: true });
})();
